<script>
    import SubViewMonster from './subViewMonster.svelte'

    import { onMount } from 'svelte'
    import { CopyData, BaseCount, ActiveMonster, PlayMonsterSetting, CheckMonsterInnerTab, PlayData } from '../../script/handle/play'

    export let Info, Monsters, DataCheck
    let MonsterData = [], activeMonster = 0, ActiveTab = 1
    CopyData.subscribe(value => {MonsterData = value})
    ActiveMonster.subscribe(value => {activeMonster = value})

    function onClickTab(_value) {
        $ActiveMonster = _value
        ActiveTab = CheckMonsterInnerTab(activeMonster)
    }

    async function onReset() {
        Info = [true, true, true, true]
        await PlayMonsterSetting(DataCheck)
    }

    onMount(async () => {
        await PlayMonsterSetting(DataCheck)
    })
</script>

{#await MonsterData}
    Lodding...
{:then data}     
    {#if typeof data == 'object'}
        <div class='monsters' class:InfoNull={!(Info[0] || Info[1] || Info[2])}>
            {#if data.length > 0}
                <div class="baseEquipment">
                    <div class="title">남은 장비 수</div>
                    {#each $BaseCount as item, i}
                        {#if item > 0}
                            <div class="item">
                                <img
                                    src="../img/equipment/base/{(i+1)}.png"
                                    alt="equip_{(i+1)}"
                                >
                                {item} 개
                            </div>
                        {/if}
                    {/each}
                </div>
            {/if}

            {#if data.length > 0}
                <div class="tabMenu">
                    {#each data as monster, i}
                        <div
                            class="tab"
                            on:click={() => onClickTab(i)}
                            class:active={activeMonster == i}
                            class:last={data.length == (i+1)}
                        >
                            {monster.name}
                        </div>
                    {/each}
                </div>

                <div class="inner">
                    <SubViewMonster
                        bind:Position={activeMonster}
                        bind:Monster={MonsterData[activeMonster]}
                        bind:ActiveTab bind:DataCheck
                    />
                </div>
            {:else}
                {#if $PlayData.monsterData.length == 0}
                    <div class="none">몬스터가 비어 있습니다.</div>
                {:else}
                    <div class="none reset" on:click={onReset}>
                        모든 정보를 선택했습니다.<br>
                        초기화 하시겠습니까?
                        <p>데이터 리셋</p>
                    </div>
                {/if}
            {/if}
        </div>
    {/if}
{/await}

<style lang="scss">
    .baseEquipment {
        width: calc(100% - 40px);
        height: fit-content;
        padding: 33px 20px;

        .title {
            color: $cl3;
            font-size: 18px;
            font-family: aggro;
        }

        .item {
            width: calc(14% - 10px);
            height: fit-content;
            padding: 5px;
            display: inline-block;

            color: $cl2;
            font-size: 14px;
            font-family: aggro;
            text-align: center;

            img { width: 100%; }
        }
    }

    .monsters {
        width: calc(65% - 6px);
        height: fit-content;
        margin-top: 30px;
        border: 3px solid $cl3;

        display: inline-block;
        vertical-align: top;

        &.InfoNull { width: calc(100% - 30px - 4px); }

        .tabMenu {
            background: $cl6;
            width: calc(100%);
            padding: 13px 0px;
            text-align: center;
            display: flex;

            .tab {
                padding: 0px 18px;
                border-right: 1px solid $cl1;
                color: $cl3;
                font-size: 16px;
                font-family: aggro;

                &.active { color: $cl2; }
                &:hover:not(.active) { color: $cl4; cursor: pointer; }
                &.last { border: none; }

                @include mobile { font-size: 12px; }
            }
        }

        .inner {
            width: calc(100% - 40px);
            height: fit-content;
            padding: 20px;
        }

        @include mobile { width: calc(100% - 6px); }
        @include tablet { width: calc(100% - 6px); }
    }

    .none {
        padding: 33px 20px;
        color: $cl4;
        font-size: 24px;
        font-family: aggro;

        p { display: none; }

        &.reset:hover {
            background: $cl4;
            color: $cl2;
            cursor: pointer;

            p { display: block; }
        }
    }
</style>